import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {DomSanitizer} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";
import {NgIf} from "@angular/common";


@Component({
  selector: 'app-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  standalone: true,
  imports: [
    NgIf
  ],
  styleUrls: ['./pdf-dialog.component.css']
})
export class PdfDialogComponent implements OnInit {

  @Input()
  url: string;

  innerHTML: any;

  constructor(public modal: NgbActiveModal,
              private _domSanitizer: DomSanitizer,
              private _http: HttpClient) {
  }

  ngOnInit() {
    this.srcUrl();
  }

  private srcUrl() {
    this.innerHTML = this._domSanitizer.bypassSecurityTrustHtml(
      `<object data="${this.url}"
              type='application/pdf'
              class='embed-responsive-item'
              style="min-height: 750px; width: 100%;">
          ไม่สามารถแสดงไฟล์ PDF ได้ไฟล์อาจถูกลบหรือเสียหาย
          </object>`
    );
  }
}
